import React, { Component } from 'react';
import PropTypes from 'prop-types'
import Button from '@material-ui/core/Button';
import { renderMarkdownFile, renderMarkdown } from 'utils'
import StyleSheet from 'styles'

import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

export class TextAgreement extends Component {

  static propTypes = {
    open: PropTypes.bool,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func
  }

  static defaultProps = {
    theme: 'light',
    open: false,
  }

  state = {
    open: false,
  };

  constructor(props){
    super(props)
    this.state = { body: '' }
  }

  componentDidUpdate(prevProps) {
    const { mdfile, mdtext } = prevProps
    if(mdfile !== this.props.mdfile || mdtext !== this.props.mdtext) {
      this.updateContentFromProps(this.props)
    }
  }

  componentDidMount = () => {
    this.updateContentFromProps(this.props)
  }

  updateContentFromProps = (newProps) => {
    if(newProps.mdfile) {
      renderMarkdownFile(newProps.mdfile).then(body => {
        this.setState({body})
      })
    } else if(newProps.mdtext) {
      const markdown = renderMarkdown(newProps.mdtext)
      this.setState({body: markdown})
    }
  }

  handleRequestClose = () => {
    this.setState({ open: false });
  };

  handleDisagree = () => {
    this.props.onCancel()
  }

  handleAgree = () => {
    this.props.onConfirm()
  }

  render() {
    return (
      <div>
        <Dialog open={this.props.open} classes={{paper: styles.dialog}}>
          <DialogTitle className={styles.dialogTitle}>
            {this.props.title}
          </DialogTitle>
          <DialogContent className={styles.dialogContent}>
            <div className={styles.tncs}>
            { this.props.children }
            </div>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleDisagree} color="primary">
              {this.props.disabled ? 'Close' : 'Disagree'}
            </Button>
            {!this.props.disabled &&
              <Button onClick={this.handleAgree} color="primary">
                Agree
              </Button>
            }
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

export const styles = StyleSheet({
  dialogContent: {
    backgroundColor: '#FFF',
    padding: 24,
  },
  dialogTitle: {
    '& h6': {
      color: '#1B3044'
    }
  },
  dialog: {
    backgroundColor: '#EEE',
  },
  tncs: {
    minHeight: 350
  }
})